<template>

<com-item name="game.affinity.winrate" :size="size" :loading="loading" :is-empty="!active" :has-more="hasMore" v-on:more="onMore" title="Win Rate">

	<template v-slot:about>

		<p>{{ your | capitalise }} win rate for games sharing these attributes.</p>

	</template>

	<template v-slot:stats>

		<div class="winrate" v-if="active">

			<div class="winrate-row" v-for="(item, index) in items" :key="index" v-on:click="onSelect(item)" v-tooltip="'View ' + item.name + ' games'">

				<div class="winrate-row-head">

					<div class="winrate-row-name">{{ item.name }}<span class="winrate-row-type" v-if="hasMultipleTypes">{{ item.type }}</span></div>

					<div class="winrate-row-rate">{{ item.rate }}%</div>

				</div>

				<div class="winrate-row-meta">

					<span class="winrate-row-delta" :class="deltaClass(item.delta)" v-if="item.delta !== null">{{ item.delta > 0 ? '+' : '' }}{{ item.delta }}%</span>

					<span class="winrate-row-record">{{ item.wins }}W / {{ item.total - item.wins }}L</span>

				</div>

				<div class="winrate-row-bar">

					<div class="winrate-row-bar-fill" :style="{ width: item.rate + '%' }" :class="barClass(item.rate)" />

					<div class="winrate-row-bar-baseline" v-if="data.overallWinRate !== null" :style="{ left: data.overallWinRate + '%' }" />

				</div>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/affinity'] },

		items: function() {

			return (this.data && this.data.winRates) ? this.data.winRates : []

		},

		total: function() {

			return (this.data && this.data.winRatesTotal) ? this.data.winRatesTotal : 0

		},

		hasMore: function() { return this.total > 5 },

		active: function() { return !this.loading && this.items.length },

		hasMultipleTypes: function() {

			if (this.items.length < 2) return false

			var first = this.items[0].type

			for (var i = 1; i < this.items.length; i++) {

				if (this.items[i].type !== first) return true

			}

			return false

		}

	},

	methods: {

		deltaClass: function(delta) {

			if (delta > 3) return 'is-positive'
			if (delta < -3) return 'is-negative'
			return 'is-neutral'

		},

		barClass: function(rate) {

			if (rate >= 50) return 'is-winning'
			return 'is-losing'

		},

		onMore: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityWinRate',
				id: parseInt(this.$route.params.game) || 0
			})

		},

		onSelect: function(item) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityAttribute',
				id: parseInt(this.$route.params.game) || 0,
				attrType: item.type,
				attrId: item.id
			})

		}

	}

}

</script>

<style scoped>

.winrate {
	width: 100%;
}

.winrate-row {
	min-height: 64px;
	padding: 8px 15px;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.winrate-row:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.winrate-row:hover {
	background-color: rgba(72, 129, 187, 0.1);
}

.winrate-row-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 2px;
}

.winrate-row-name {
	font-size: 14px;
	font-weight: 600;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
}

.winrate-row-type {
	font-size: 10px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.3px;
	color: #999;
	margin-left: 6px;
}

.winrate-row-rate {
	font-size: 18px;
	font-weight: 700;
	color: #333;
	flex-shrink: 0;
	margin-left: 10px;
}

.winrate-row-meta {
	display: flex;
	gap: 8px;
	margin-bottom: 6px;
}

.winrate-row-delta {
	font-size: 12px;
	font-weight: 700;
}

.winrate-row-delta.is-positive { color: #2FC482; }
.winrate-row-delta.is-negative { color: #c0392b; }
.winrate-row-delta.is-neutral { color: #666; }

.winrate-row-record {
	font-size: 11px;
	color: #999;
}

.winrate-row-bar {
	height: 4px;
	background-color: rgba(0, 0, 0, 0.04);
	border-radius: 2px;
	position: relative;
}

.winrate-row-bar-fill {
	height: 100%;
	border-radius: 2px;
}

.winrate-row-bar-fill.is-winning { background-color: #2FC482; }
.winrate-row-bar-fill.is-losing { background-color: #c0392b; }

.winrate-row-bar-baseline {
	position: absolute;
	top: -3px;
	width: 2px;
	height: 10px;
	background-color: rgba(0, 0, 0, 0.2);
	transform: translateX(-50%);
}

</style>
